var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicTableRow = exports.ChildrenToColumnWithStyle = exports.ChildrenToRow = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Touchable = _interopRequireDefault(require("./Touchable"));

var _Basic = require("../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/Layouting.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var generateChildrenToRowKey = function generateChildrenToRowKey(child, index) {
  return "childrenToRow_" + child.props.key + "_" + index;
};

var generateBasicTableRowKey = function generateBasicTableRowKey(child, index) {
  return "basicTableRow_" + (child.props.keyValue || '') + "_" + index;
};

var ChildrenToRow = function ChildrenToRow(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_Basic.Row, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  }, children.filter(function (child) {
    return child !== null;
  }).map(function (child, index) {
    return _react.default.createElement(_Basic.Column, {
      flexing: true,
      center: true,
      key: generateChildrenToRowKey(child, index),
      width: [1 / children.length],
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 17
      }
    }, child);
  }));
};

exports.ChildrenToRow = ChildrenToRow;

var ChildrenToColumnWithStyle = function ChildrenToColumnWithStyle(_ref2) {
  var children = _ref2.children,
      columnStyling = _ref2.columnStyling;
  return _react.default.createElement(_Basic.Column, (0, _extends2.default)({}, columnStyling, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }), children);
};

exports.ChildrenToColumnWithStyle = ChildrenToColumnWithStyle;

var BasicTableRow = function BasicTableRow(_ref3) {
  var children = _ref3.children,
      onPress = _ref3.onPress,
      href = _ref3.href,
      NavWrapper = _ref3.NavWrapper,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["children", "onPress", "href", "NavWrapper"]);

  var row = _react.default.createElement(_Basic.Row, (0, _extends2.default)({
    borderBox: true
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }), _react.default.Children.map(children, function (child, index) {
    return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
      key: generateBasicTableRowKey(child, index),
      isFlex: true
    }, _objectSpread({
      width: child.props.tableWidth,
      maxWidth: child.props.maxWidth
    }, child.props.columnStyling), {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 17
      }
    }), child);
  }));

  return _react.default.createElement(_Touchable.default, {
    onPress: onPress,
    href: href,
    NavWrapper: NavWrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 9
    }
  }, row);
};

exports.BasicTableRow = BasicTableRow;